import { FC } from "react";
import { Outlet } from "react-router";

import { useAuthentication } from "@authentication";
import { useAnalyticsGtm } from "@unbooking/analytics-gtm";
import {
  ANALYTICS_AGENCY_NAME,
  ANALYTICS_DEFAULT_PAGE_TYPE,
  ANALYTICS_SERVICE_CATEGORY,
  ANALYTICS_SERVICE_NAME,
} from "./analytics";

const ANALYTICS_CONFIG = {
  serviceName: ANALYTICS_SERVICE_NAME,
  agencyName: ANALYTICS_AGENCY_NAME,
  defaultServiceCategory: ANALYTICS_SERVICE_CATEGORY,
  defaultPageType: ANALYTICS_DEFAULT_PAGE_TYPE,
};

/**
 * Pushes GTM `page_view` / `user_login` events to `window.dataLayer` on every navigation.
 * The page type and subcategory come from the deepest matched route's `handle.analytics`
 * (see `src/routes.tsx`). Must be rendered by a data router, since the library uses `useMatches`.
 */
export const AnalyticsLayout: FC = () => {
  const { isAuthenticated, session } = useAuthentication();

  useAnalyticsGtm({
    authState: { isAuthenticated, userEmail: session?.email },
    config: ANALYTICS_CONFIG,
  });

  return <Outlet />;
};
